import React from 'react';
import numeral from 'numeral';

const NumeralTypes = {
  NUMBER: 'NUMBER',
  DECIMAL: 'DECIMAL',
  PERCENTAGE: 'PERCENTAGE',
  PERCENT_4: 'PERCENT_4',
  PERCENT_2: 'PERCENT_2'
};
const FormatTypes = {
  DEFAULT: '(0,0.[00000])',
  DECIMAL: '(0,0.00)',
  PERCENTAGE: '0.000000%',
  PERCENT_4: '0.0000%',
  PERCENT_2: '0.00%'
};
const getFormat = type => {
  if (type === NumeralTypes.DECIMAL) {
    return FormatTypes.DECIMAL;
  }
  if (type === NumeralTypes.PERCENTAGE) {
    return FormatTypes.PERCENTAGE;
  }
  if (type === NumeralTypes.PERCENT_4) {
    return FormatTypes.PERCENT_4;
  }
  if (type === NumeralTypes.PERCENT_2) {
    return FormatTypes.PERCENT_2;
  }
  return FormatTypes.DEFAULT;
};
const getFixedPrecision = type => {
  if (type === NumeralTypes.PERCENTAGE) {
    return '8';
  }
  if (type === NumeralTypes.PERCENT_4) {
    return '6';
  }
  return '2';
};
const getValue = _ref => {
  let {
    children,
    type,
    customFormat,
    fixedPrecision
  } = _ref;
  const format = customFormat ? customFormat : getFormat(type);
  const toFixedPrecision = fixedPrecision ? fixedPrecision : getFixedPrecision(type);
  const value = children === null || children === undefined // eslint-disable-line no-undefined
  ? null : numeral(Number(children).toFixed(toFixedPrecision)).format(format);
  return value;
};
const Numeral = _ref2 => {
  let {
    additionalClassNames,
    children,
    type,
    customFormat,
    fixedPrecision
  } = _ref2;
  const value = getValue({
    children,
    type,
    customFormat,
    fixedPrecision
  });
  return /*#__PURE__*/React.createElement("span", {
    className: additionalClassNames(value)
  }, value);
};
Numeral.defaultProps = {
  additionalClassNames: () => '',
  customFormat: '',
  fixedPrecision: ''
};

const DecimalRenderer = _ref => {
  let {
    value
  } = _ref;
  return !value && value !== 0 ? null : /*#__PURE__*/React.createElement(Numeral, {
    type: NumeralTypes.DECIMAL
  }, value);
};
const NumberRenderer = _ref2 => {
  let {
    value
  } = _ref2;
  return !value && value !== 0 ? null : /*#__PURE__*/React.createElement(Numeral, {
    type: NumeralTypes.NUMBER
  }, value);
};

export { DecimalRenderer, NumberRenderer, NumeralTypes, Numeral as default, getValue };
